<template>
  <v-container class="anytime-consultation-inquiry">
    <!-- タイトル -->
    <div>
      <span style="font-size: 1.5em; font-weight: bold;">
        {{ consultation.title }}事前問診 (ID: {{ consultation.id }})
      </span>
    </div>
    <!-- ユーザー情報・相談詳細 -->
    <div :class="{'mt-4':true, 'inquery-grid-container': true}">
      <!-- 左上: ユーザー情報 -->
      <v-card
        class="pa-4 inquery-grid-user"
        variant="outlined"
        tile
      >
        <anytime-consultation-user-info :consultation="consultation" />
      </v-card>
      <!-- 左下: 相談契約情報 -->
      <v-card
        class="pa-4 inquery-grid-contract"
        variant="outlined"
        tile
      >
        <div>
          <b>相談方法別の利用可否</b>:
        </div>
        <div class="d-flex flex-wrap">
          <v-chip
            class="ma-1"
            label
            :color="consultation.useReservation ? 'red' : 'default'"
          >
            <span class="text-black">夜間</span>
            <v-icon
              v-if="consultation.useReservation"
              color="rgba(0, 0, 0, .54)"
              size="small"
              end
            >
              mdi-circle-outline
            </v-icon>
            <v-icon
              v-if="!consultation.useReservation"
              size="small"
              end
            >
              mdi-close
            </v-icon>
          </v-chip>
          <v-chip
            class="ma-1"
            label
            :color="consultation.useAnytimeConsultation ? 'red' : 'default'"
          >
            <span class="text-black">いつでも</span>
            <v-icon
              v-if="consultation.useAnytimeConsultation"
              color="rgba(0, 0, 0, .54)"
              size="small"
              end
            >
              mdi-circle-outline
            </v-icon>
            <v-icon
              v-if="!consultation.useAnytimeConsultation"
              size="small"
              end
            >
              mdi-close
            </v-icon>
          </v-chip>
          <v-chip
            class="ma-1"
            label
            :color="consultation.useDaytimeAdvice ? 'red' : 'default'"
          >
            <span class="text-black">日中助産師</span>
            <v-icon
              v-if="consultation.useDaytimeAdvice"
              color="rgba(0, 0, 0, .54)"
              size="small"
              end
            >
              mdi-circle-outline
            </v-icon>
            <v-icon
              v-if="!consultation.useDaytimeAdvice"
              size="small"
              end
            >
              mdi-close
            </v-icon>
          </v-chip>
        </div>

        <div>
          <b>相談員種別の利用可否</b>:
        </div>
        <div class="d-flex flex-wrap">
          <v-chip
            class="ma-1"
            label
            :color="
              consultation.pediatricianEnabled
                ? 'red'
                : 'default'
            "
          >
            <span class="text-black">小児科医</span>
            <v-icon
              v-if="consultation.pediatricianEnabled"
              color="rgba(0, 0, 0, .54)"
              size="small"
              end
            >
              mdi-circle-outline
            </v-icon>
            <v-icon
              v-if="!consultation.pediatricianEnabled"
              size="small"
              end
            >
              mdi-close
            </v-icon>
          </v-chip>
          <v-chip
            class="ma-1"
            label
            :color="
              consultation.obstetricsEnabled
                ? 'red'
                : 'default'
            "
          >
            <span class="text-black">産婦人科医</span>
            <v-icon
              v-if="consultation.obstetricsEnabled"
              color="rgba(0, 0, 0, .54)"
              size="small"
              end
            >
              mdi-circle-outline
            </v-icon>
            <v-icon
              v-if="!consultation.obstetricsEnabled"
              size="small"
              end
            >
              mdi-close
            </v-icon>
          </v-chip>
          <v-chip
            class="ma-1"
            label
            :color="
              consultation.midwifeEnabled
                ? 'red'
                : 'default'
            "
          >
            <span class="text-black">助産師</span>
            <v-icon
              v-if="consultation.midwifeEnabled"
              color="rgba(0, 0, 0, .54)"
              size="small"
              end
            >
              mdi-circle-outline
            </v-icon>
            <v-icon
              v-if="!consultation.midwifeEnabled"
              size="small"
              end
            >
              mdi-close
            </v-icon>
          </v-chip>
        </div>
      </v-card>

      <!-- 右側: 相談詳細 -->
      <v-card
        class="pa-4 inquery-grid-detail"
        variant="outlined"
        tile
      >
        <div style="line-height: 2;">
          <div
            class="mb-2"
          >
            <b>質問日時</b>： {{ consultation.askedAt }}
          </div>

          <div v-if="consultation.diseaseStartedAt">
            <b>いつから症状が出ているか</b>： {{ consultation.diseaseStartedAt }}
          </div>

          <!-- 相談内容に最も近い内容/一番気になっていること など。LLMによりハイライトされることがある -->
          <consultation-details-highlighted-with-extracted-questions
            :consultation-details="consultation?.consultationDetails"
            :extracted-questions="extractedQuestions"
            :selected-question-id="selectedUnansweredQuestionId"
          />
        </div>

        <div class="mt-2">
          <span><b>相談したいこと</b>： </span><br>

          <!-- ユーザへの質問リスト -->
          <div
            v-if="hasQuestionList"
            style="width: 80%; background-color: #ededed; margin: 4px 0; padding: 2px 4px 8px 4px; border-radius: 8px;"
          >
            <div style="display: flex; justify-content: flex-start; align-items: center;">
              <p style="font-size: 12px; font-weight: bold;">
                ユーザーへの質問リスト
              </p>
              <v-btn
                :color="isOpen ? null : 'grey-darken-4'"
                density="comfortable"
                outlined
                size="small"
                @click="toggleQuestionList"
              >
                {{ isOpen ? "閉じる▲" : "開く▼" }}
              </v-btn>
            </div>
            <ul
              v-if="isOpen"
              style="font-size: 12px; margin-left: 8px; margin-bottom: 8px; padding-left: 8px;"
            >
              <li
                v-for="(question, index) in consultation.questionList"
                :key="index"
              >
                {{ question }}
              </li>
            </ul>
            <p style="font-size: 10px;">
              ※ユーザーの相談文に不明点がある場合、ご利用ください。
            </p>
          </div>

          <!-- 相談文（相談したいこと）の表示 -->

          <div class="highlight-text">
            <!-- キーワード検索によるハイライト。類似事例検索結果のAnytimeConsultationView経由で開く場合にのみこちらが使われる -->
            <!-- この表示の場合、AI添削による疑問の下線ハイライトが行われない。実装・修正コストを考慮し、この挙動は許容している。
             https://github.com/kidspublic/QA_issues/issues/756 -->
            <additional-details-highlighted-with-keywords
              v-if="hasKeywordHighlight"
              :keywords="keywords"
              :additional-details="normalizedAdditionalDetails"
            />

            <!-- 疑問の抽出結果によるハイライト。通常はこちら。-->
            <additional-details-highlighted-with-extracted-questions
              v-else
              :additional-details="normalizedAdditionalDetails"
              :extracted-questions="extractedQuestions"
              :selected-question-id="selectedUnansweredQuestionId"
            />
          </div>
        </div>

        <!-- AIが相談文から抽出した疑問 -->
        <anytime-consultation-extracted-questions />

        <!-- 添付画像 -->
        <div
          class="mt-2"
        >
          <span><b>添付画像</b>： </span>
          <span v-if="!consultation.image">
            なし
          </span>
          <div v-else>
            <img
              :src="consultation.image"
              style="max-width: 90%; height: 48px; cursor: pointer;"
              oncontextmenu="return false;"
              onselectstart="return false;"
              onmousedown="return false;"
              @click="showMedia"
            >
          </div>
        </div>

        <consultation-warning-notice
          v-if="isMidwifeTeensConsultation"
          :text="midwifeTeensWarningText"
        />
      </v-card>
    </div>
    <!-- 画像拡大用 -->
    <v-container class="ma-0 pa-0">
      <v-row justify="center">
        <v-col class="ma-0 pa-0">
          <v-dialog
            v-model="imageDialog"
            max-width="60%"
            scrollable
          >
            <v-card class="my-5">
              <img
                v-if="imageUrl !== undefined"
                :src="imageUrl"
                class="secure-image"
                style="display: block; width: 100%; max-height: 100%"
              >
              <v-btn
                position="absolute"
                class="icon-button"
                color="gray lighten-4"
                fab
                size="x-small"
                @click="closeDialog()"
              >
                ×
              </v-btn>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-container>
    <!--// 画像拡大用 -->
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import AnytimeConsultationUserInfo from "./AnytimeConsultationUserInfo.vue";
import AnytimeConsultationExtractedQuestions from "./AnytimeConsultationExtractedQuestions.vue";
import AdditionalDetailsHighlightedWithKeywords from "./AdditionalDetailsHighlightedWithKeywords.vue";
import AdditionalDetailsHighlightedWithExtractedQuestions from "./AdditionalDetailsHighlightedWithExtractedQuestions.vue";
import ConsultationDetailsHighlightedWithExtractedQuestions from "./ConsultationDetailsHighlightedWithExtractedQuestions.vue";
import ConsultationWarningNotice from "./ConsultationWarningNotice.vue";

export default {
  name: "AnytimeConsultationInquiry",
  components: {
    AnytimeConsultationUserInfo,
    AnytimeConsultationExtractedQuestions,
    AdditionalDetailsHighlightedWithKeywords,
    AdditionalDetailsHighlightedWithExtractedQuestions,
    ConsultationDetailsHighlightedWithExtractedQuestions,
    ConsultationWarningNotice
  },
  props: {
    keywords: {
      type: Array,
      default: () => {[];}
    },
  },
  data: () => ({
    imageUrl: "",
    imageDialog: false,
    isOpen: false,
  }),
  computed: {
    ...mapGetters({
      answer: "anytimeConsultationAnswer",
      consultation: "anytimeConsultation",
      extractedQuestions: "consultationExtractedQuestions",
      selectedUnansweredQuestionId: "selectedUnansweredQuestionId",
    }),
    hasKeywordHighlight() {
      return Array.isArray(this.keywords) && this.keywords.length > 0;
    },
    normalizedAdditionalDetails() {
      return typeof this.consultation?.additionalDetails === "string"
        ? this.consultation.additionalDetails
        : "";
    },
    isMidwifeTeensConsultation() {
      return this.consultation?.department_type === "midwife" && this.consultation?.inPregnancy === "teens";
    },
    midwifeTeensWarningText() {
      return "＜自死や被虐待のリスクが高いと判断された場合＞\n信頼できる大人への相談や夜間相談の利用を促す文章を送信してください。（小中高生フォームからのいつでも相談では本人特定ができないため、運営へのハイリスク者報告は不要です）";
    },
    hasQuestionList() {
      return !this.isMidwifeTeensConsultation && this.consultation.questionList && this.consultation.questionList.length > 0;
    },
  },
  methods: {
    showMedia: function(e) {
      this.$data.imageDialog = true;
      this.$data.imageUrl = e.currentTarget.getAttribute("src");
    },
    closeDialog: function(e) {
      this.$data.imageDialog = false;
    },
    toggleQuestionList() {
      this.isOpen = !this.isOpen;
    },
  }
};
</script>

<style lang="scss">
.inquery-grid-container{
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-template-areas  : "user detail"
                         "contract  detail";

  @media (max-width: 600px) {
    display: flex;
    flex-direction: column;
  }
  .is-minimum & {
    display: flex;
    flex-direction: column;
    .inquery-grid-contract {
      display: none;
    }
  }
}

.inquery-grid-user{
  grid-area: user;
}
.inquery-grid-contract{
  grid-area: contract;
}
.inquery-grid-detail{
  grid-area: detail;
}

.icon-button {
  top: 0;
  right: 0;
  font-size: 18px;
}
.v-theme--light.v-card.v-card--variant-outlined {
  border: 1px solid rgba(0, 0, 0, .12);
}

</style>
